import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
export function Testimonials() {
  return <section className="border-y border-slate-200/80 bg-white py-24 lg:py-32" data-id="element-145" data-mp="3ksqgb9iahk82">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-146" data-mp="3fxuittuaa4nk">
        <Reveal className="max-w-2xl" data-id="element-147" data-mp="3b1cjxalmx0j5">
          <p className="text-[13px] font-medium uppercase tracking-[0.16em] text-accent" data-id="element-148" data-mp="3b0aycc6zsvn6">
            Testimonios
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink lg:text-5xl" data-id="element-149" data-mp="31zw9x3yqf0fg">
            Lo que dicen nuestros clientes
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-150" data-mp="2x2mnzyajx6wd">
          {testimonials.map((item, i) => <li key={item.name} data-id="element-151" data-mp="2s4319vo4vr2y" data-mpi={i}>
              <Reveal delay={i * 0.09} data-id="element-152" data-mp="v9opblu3fk3i">
                <figure className="flex h-full flex-col rounded-3xl border border-slate-200/80 bg-canvas p-8 transition-all duration-300 hover:-translate-y-1.5 hover:bg-white hover:shadow-lift" data-id="element-153" data-mp="v8ncpcxfipjo">
                  <QuoteIcon className="h-6 w-6 text-accent/40" strokeWidth={1.6} aria-hidden="true" data-id="element-154" data-mp="h4dfoti1e27v" />
                  <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-155" data-mp="7927yv51pv9m">
                    “{item.quote}”
                  </blockquote>
                  <figcaption className="mt-7 flex items-center gap-3.5 border-t border-slate-200 pt-6" data-id="element-156" data-mp="zwppu2exm7sk">
                    <img src={item.avatar} alt={`Retrato de ${item.name}`} className="h-11 w-11 rounded-full object-cover" width={88} height={88} data-id="element-157" data-mp="14w2b4iq5n6t1" />
                    <div data-id="element-158" data-mp="1ivad1jdpct0x">
                      <p className="text-[15px] font-semibold text-ink" data-id="element-159" data-mp="1iusay64czkl3">{item.name}</p>
                      <p className="text-sm text-slate-500" data-id="element-160" data-mp="1nlqsf9132opx">{item.company}</p>
                    </div>
                  </figcaption>
                </figure>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}